module.exports = __webpack_public_path__ + "static/media/postcard3thumb.fe846f46.jpg";